<template>
  <footer class="home">
    <div class="wrapper footer-wrapper">
      <div class="footer-text">
        <div>
          <p>PIVA 10905030010</p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>

  export default {
    name: 'FooterHome'
  }
</script>
